export const formatDate = (type: string, period: number): string => {
  const event = new Date();

  switch (type) {
    case 'minutes':
      event.setMinutes(event.getMinutes() - period);
      break;
    case 'hours':
      event.setHours(event.getHours() - period);
      break;
    case 'days':
      event.setDate(event.getDate() - period);
      break;
    default:
      break;
  }
  return event.toJSON();
};
